import { render, staticRenderFns } from "./FeatureNav.vue?vue&type=template&id=95c1f72c&scoped=true&"
import script from "./FeatureNav.vue?vue&type=script&lang=js&"
export * from "./FeatureNav.vue?vue&type=script&lang=js&"
import style0 from "./FeatureNav.vue?vue&type=style&index=0&id=95c1f72c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c1f72c",
  null
  
)

export default component.exports